<template>
  <div class="idor-vul">
    <!-- Request Information Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.requestInformation') }}</h3>
      <el-table
        :data="requestData"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="item"
          :label="$t('vulnerabilityInformation.item')"
          width="180"
        />
        <el-table-column
          prop="information"
          :label="$t('vulnerabilityInformation.information')"
        />
      </el-table>
    </div>

    <!-- Response Information Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.responseInformation') }}</h3>
      <el-table
        :data="responseData"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="accountRole"
          :label="$t('vulnerabilityInformation.accountRole')"
          width="180"
        />
        <el-table-column
          prop="responseBody"
          :label="$t('vulnerabilityInformation.responseBody')"
        />
      </el-table>
    </div>

    <!-- Response Similarities Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.responseSimilarities') }}</h3>
      <el-table
        :data="similarityData"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="originalAccount"
          :label="$t('vulnerabilityInformation.originalAccount')"
        />
        <el-table-column
          prop="attackAccount"
          :label="$t('vulnerabilityInformation.attackAccount')"
        />
        <el-table-column
          prop="similarity"
          :label="$t('vulnerabilityInformation.similarity')"
        />
        <el-table-column
          prop="isVulnerable"
          :label="$t('vulnerabilityInformation.isVulnerable')"
        >
          <template #default="scope">
            <el-tag :type="scope.row.isVulnerable === 'YES' ? 'danger' : 'success'">
              {{ scope.row.isVulnerable }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- Detection Criteria Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.detectionCriteria') }}</h3>
      <div class="code-block">
        <pre><code>{{ detectionCriteria }}</code></pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdorVul',
  props: {
    vul: {
      type: Object,
      required: true,
    },
  },
  computed: {
    requestData() {
      const { apiPath, apiMethod, pocScript } = this.vul;
      let postData = '-';

      // 如果存在 pocScript，尝试解析获取 postData
      if (pocScript) {
        try {
          const pocData = JSON.parse(pocScript);
          postData = pocData.postData || '-';
        } catch (e) {
          console.warn('Failed to parse pocScript:', e);
          postData = '-';
        }
      }

      return [
        {
          item: 'URL',
          information: apiPath,
        },
        {
          item: 'Method',
          information: apiMethod,
        },
        {
          item: 'Request Body',
          information: postData,
        },
      ];
    },
    responseData() {
      if (!this.vul.pocScriptOutput) return [];

      const output = JSON.parse(this.vul.pocScriptOutput);
      return [
        {
          accountRole: 'Administrator',
          responseBody: output.responses.original,
        },
        {
          accountRole: 'Normal User',
          responseBody: output.responses.attacker,
        },
        {
          accountRole: 'Guest',
          responseBody: output.responses.unauthenticated,
        },
      ];
    },
    similarityData() {
      if (!this.vul.pocScriptOutput) return [];

      const output = JSON.parse(this.vul.pocScriptOutput);
      return [
        {
          originalAccount: 'Administrator',
          attackAccount: 'Normal User',
          similarity: output.similarities.originalVsAttacker.similarity,
          isVulnerable: output.similarities.originalVsAttacker.isAboveThreshold ? 'YES' : 'NO',
        },
        {
          originalAccount: 'Administrator',
          attackAccount: 'Guest',
          similarity: output.similarities.originalVsUnauthenticated.similarity,
          isVulnerable: output.similarities.originalVsUnauthenticated.isAboveThreshold ? 'YES' : 'NO',
        },
        {
          originalAccount: 'Normal User',
          attackAccount: 'Guest',
          similarity: output.similarities.attackerVsUnauthenticated.similarity,
          isVulnerable: output.similarities.attackerVsUnauthenticated.isAboveThreshold ? 'YES' : 'NO',
        },
      ];
    },
    detectionCriteria() {
      if (!this.vul.pocScriptOutput) return '';

      try {
        const output = JSON.parse(this.vul.pocScriptOutput);
        return output.reasoning || '';
      } catch (error) {
        console.error('Failed to parse POC script output:', error);
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.idor-vul {
  .idor-section {
    margin-bottom: 30px;
  }

  h3 {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
  }

  .code-block {
    background: #1e1e1e;
    border-radius: 4px;
    padding: 16px;

    pre {
      margin: 0;

      code {
        color: #fff;
        font-family: monospace;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
  }

  :deep(.el-table) {
    margin-bottom: 16px;

    .el-table__header-wrapper {
      th {
        background-color: #2b2b2b;
        color: #ffffff;
      }
    }
  }
}
</style>
